// 引入工具函数
import req from '@/utils/request';

// 生产订单
export const changeToCtOrder = (params) => {
    return req.post('/order/payment/changeToCtOrder', params);
}

//完成订单
export const completeOrder = (params) => {
    return req.post('/order/payment/new/submitOrderPayment', params);
}

//判断是否存在有效订单
export const judeExitCtOrder = (params) => {
    return req.get('/ctOrder/existCtOrder', params);
}

//取消订单
export const cancelCtOrder = (params) => {
    return req.get('/ctOrder/cancelCtOrder', params);
}

//查询订单明细
export const getOrderDetail = (params) => {
    return req.get('/order/getOrderDetail', params);
}

//查询可统筹剂量
export const calcYbTcDoseNum = (params) => {
    return req.get('/order/payment/calcYbTcDoseNum', params);
}